import 'ol/ol.css';

import * as Condition from 'ol/events/condition';
import * as Control from "ol/control";
import * as Extent from "ol/extent";
import * as Coordinate from "ol/coordinate";

import Collection from 'ol/Collection';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Overlay from "ol/Overlay";
import View from 'ol/View';

import {Polygon as PolygonGeom} from 'ol/geom';
import {Draw, Modify, Select, Snap} from 'ol/interaction';
import {Image, Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Projection} from 'ol/proj';
import {Vector as VectorSource, ImageStatic} from 'ol/source';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';

class Polygon {
    constructor (args) {
        let self = this;

        self._args = args;
        return self._init();
    }

    _state = {
        vectors : []
    };

    _createMap = () => {
        let self = this;

        self._state.vectors.push(self._createVector(0));
        self._state.vectors.push(self._createVector(1));

        self._state.imageLayer = self._createImageLayer();
        self._state.overlay    = self._createOverlay(document.getElementById('popup'));
        self._state.view       = self._createView();

        self._state.map = new Map({
            layers: 		[ self._state.imageLayer ].concat(self._state.vectors),
            overlays: 	    [ self._state.overlay ],
            controls: 		Control.defaults({
                zoom        : true,
                attribution : false,
                rotate      : false
            }),
            target          : self._args.target,
            view            : self._state.view
        });

        // let extent = self._state.vectors[0].getSource().getExtent();
        // self._state.map.getView().fit(extent, self._state.map.getSize());
        // self._state.map.getView().fit([0, 0, self._args.image.width, self._args.image.height], self._state.map.getSize());

        let fullscreen = new Control.FullScreen();
        self._state.map.addControl(fullscreen);

        self._addInteractions();
        self._setEvents();
    };

    _createImageLayer = () => {
        let self = this;

        let imageStatic = self._createImageStatic();

        return new Image({
            source: imageStatic,
        });
    };

    _createImageStatic = () => {
        let self = this;

        return new ImageStatic({
            url         : self._args.image.path,
            imageExtent : [ 0, 0, self._args.image.width, self._args.image.height ]
        });
    };

    _createView = () => {
        let self = this;

        let projection = self._createProjection();

        let x = 50;
        let y = 50;

        if (self._args.image.width > self._args.image.height) {
            //y = self._args.image.width - self._args.image.height + 50;
        } else {
            //x = self._args.image.height - self._args.image.width + 50;
        }

        return new View({
            projection: 	projection,
            center: 		Extent.getCenter([ 0, 0, self._args.image.width, self._args.image.height ]),
            zoom: 			1,
            minZoom: 		1,
            maxZoom: 		6,
            // resolution :    1,
            maxResolution : 5,
            extent: 		[ -1*x, -1*y, self._args.image.width + x, self._args.image.height + y ],
            //extent: 		[ -10, -10, self._args.image.width + 20, self._args.image.height + 20 ],
            // resolutions     : self._state.imageLayer.getSource().getTileGrid().getResolutions()
        });
    };

    _createProjection = () => {
        let self = this;
        
        return new Projection({
            code: 		'olimage',
            units: 		'pixels',
            extent: 	[ 0, 0, self._args.image.width, self._args.image.height ],
        });
    };

    _createOverlay = (container) => {
        return new Overlay({
            element: 	container,
            autoPan: 	true,

            autoPanAnimation: {
                duration: 0
            },
        });
    };

    _createStyle = (vector_index) => {
        if (vector_index === 0) {
            return new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.1)'
                }),

                stroke: new Stroke({
                    color: 	'rgba(255, 255, 255, 0.5)',
                    width: 	1,
                }),

                image: new CircleStyle({
                    radius: 	7,
                    fill: 		new Fill({ color: '#ffffff' }),
                }),
            });
        } else if (vector_index === 1) {
            return new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                }),

                stroke: new Stroke({
                    color: 	'#ffcc33',
                    width: 	2,
                }),

                image: new CircleStyle({
                    radius: 	7,
                    fill: 		new Fill({ color: '#ffcc33' }),
                }),
            });
        }

        return null;
    };

    _setColor = (vector_index, color) => {
        let self = this;

        self._state.color = color;
        self._state.vectors[vector_index].getStyle().getFill().setColor(self._hexToRgba(self._state.color, 0.2));
    };

    _hexToRgba = (hex, opacity) => {
        hex = hex.replace('#', '');

        const color = {
            r: parseInt(hex.substring(0, 2), 16),
            g: parseInt(hex.substring(2, 4), 16),
            b: parseInt(hex.substring(4, 6), 16),
        };

        if (opacity) {
            opacity = opacity > 1 ? opacity / 100 : opacity;
            return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + opacity + ')';
        } else {
            return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ')';
        }
    };

    _createVector = (vector_index) => {
        let self = this;

        self._state.sourceVector = self._createSourceVector(vector_index);

        return new VectorLayer({
            source: self._state.sourceVector,
            style: self._createStyle(vector_index),
        });
    };

    _createSourceVector = (vector_index) => {
        let self = this;

        if (vector_index === 0) {
            let features = new Collection();

            self._args.background_polygons && self._args.background_polygons.forEach(function(background_polygon) {
                let feature = new Feature({
                    geometry: 	new PolygonGeom([ background_polygon.coordinates ]),
                });

                for (let property_name in background_polygon) {
                    if (property_name == 'coordinates') continue;

                    feature[property_name] = background_polygon[property_name];
                }

                features.push(feature);
            });

            return new VectorSource({
                features: features,
            });
        } else if (vector_index === 1) {
            self._state.features = new Collection();

            self._args.polygons && self._args.polygons.forEach(function(polygon) {
                let feature = new Feature({
                    geometry: 	new PolygonGeom([ polygon.coordinates ]),
                });

                for (let property_name in polygon) {
                    if (property_name == 'coordinates') continue;

                    feature[property_name] = polygon[property_name];
                }

                self._state.features.push(feature);
            });

            return new VectorSource({
                features: self._state.features,
            });
        }

        return null;
    };

    _addInteractions = () => {
        let self = this;

        self._setModify();
        self._setDraw();
        self._setSnap();
        self._setSelect();
    };

    _setModify = () => {
        let self = this;

        self._state.modify = {};

        self._state.modify.setActive = function(active) {
            self._state.modify.interaction.setActive(active);
        };

        let source = self._state.vectors[1].getSource();

        self._state.modify.interaction = new Modify({
            features        : self._state.features,
            //source          : source,
            /*deleteCondition : function (e) {
                return Condition.shiftKeyOnly(e) && Condition.singleClick(e);
            },
            pixelTolerance : 10*/
        });

        self._state.map.addInteraction(self._state.modify.interaction);
        self._state.modify.setActive(true);
    };

    _setDraw = () => {
        let self = this;

        let source = self._state.vectors[1].getSource();

        self._state.draw = {};

        self._state.draw.isEmpty = function() {
            if (!self._state.draw.getFeature()) return true;

            const coords = self._state.draw.getFeature().getGeometry().getCoordinates()[0];
            if (!coords.length || self._state.draw.isOnePoint(coords)) return true;
            return false;
        };

        self._state.draw.coordToString = function(coordXY) {
            return Coordinate.toStringXY(coordXY, 3);
        };

        self._state.draw.isOnePoint = function(coords) {
            return coords.every(function(coordXY) {
                return self._state.draw.coordToString(coords[0]) == self._state.draw.coordToString(coordXY);
            }.bind(self._state.draw));
        };

        self._state.draw.getFeature = function() {
            return self._state.draw.interaction.sketchFeature_;
        };

        self._state.draw.getActive = function() {
            return self._state.draw.interaction && self._state.draw.interaction.getActive();
        };

        self._state.draw.setActive = function(active) {
            self._state.draw.interaction.setActive(active);
        };

        self._state.draw.interaction = new Draw({
            source    : source,
            type      : 'Polygon',
            minPoints : 3,
            // freehand  : false,
            // stopClick : false,
            condition : function(e) {
                return e.pointerEvent.buttons === 1;
            }
        });
        self._state.map.addInteraction(self._state.draw.interaction);
        self._state.draw.setActive(true);
    };

    _setSelect = () => {
        let self = this;

        self._state.select = {};
        self._state.hover  = {};

        self._state.select.setActive = function(active) {
            self._state.select.interaction.setActive(active);
        };

        self._state.select.clear = function() {
            const selectedFeatures = self._state.select.interaction.getFeatures();
            selectedFeatures.forEach(selectedFeatures.remove.bind(selectedFeatures));
        };

        self._state.select.interaction = new Select();
        self._state.map.addInteraction(self._state.select.interaction);

        self._state.select.setActive(true);
    };

    _setSnap = () => {
        let self = this;

        self._state.snap = {};

        let source = self._state.vectors[1].getSource();
        self._state.snap.interaction = new Snap({source: source});

        self._state.map.addInteraction(self._state.snap.interaction);
    };

    _setEvents = () => {
        let self = this;

        let enableHover = true;

        self._state.map.getViewport().addEventListener('contextmenu', function(e) {
            e.preventDefault();
            self._rightClickHandler(e);
        });

        self._state.map.on('pointerdrag', function(e) {
            self._args.events && self._args.events.pointerdrag && self._args.events.pointerdrag(e);
        });
        self._state.map.on('moveend', function(e) {
            self._args.events && self._args.events.moveend && self._args.events.moveend(e);
        });

        self._state.draw.interaction.on('drawstart', function(e){
            enableHover = false;
        });
        self._state.draw.interaction.on('drawend', function(e) {
            self._args.events && self._args.events.created && self._args.events.created(e.feature);
            enableHover = true;
        });

        let selected = null;

        self._state.map.on('pointermove', function(e) {
            let hoverStyle = new Style({
                fill: new Fill({
                    color: self._hexToRgba(self._state.color, 0.5),
                }),
                stroke: new Stroke({
                    color: self._hexToRgba(self._state.color, 0.5),
                    width: 2,
                }),
                /*image: new CircleStyle({
                    radius : 7,
                    fill   : new Fill({
                        color: self._hexToRgba(self._state.color),
                    })
                })*/
            });

            if (e.dragging) return;
            if (!enableHover) return;

            if (selected !== null) {
                selected.setStyle(undefined);
                selected = null;
            }

            let currentFeature = self._state.map.forEachFeatureAtPixel (e.pixel, function(feature){
                selected = feature;
                feature.setStyle(hoverStyle);
                return true;
            });

            /*let currentFeature = null;

            self._state.map.forEachFeatureAtPixel(e.pixel, function(feature, l) {
                if (feature.getGeometry().getType() === 'Polygon') {
                    currentFeature = feature;
                }
            });*/

            /*
            if (currentFeature && self._state.features.getArray().indexOf(currentFeature) > -1) {
                self._state.hovered = true;
                // currentFeature.setStyle(hoverStyle);
                self._removeStyleFromFeatures(currentFeature);
            } else if (self._state.hovered) {
                self._state.hovered = false;
                self._removeStyleFromFeatures();
            }*/
        });
        self._state.map.on('dblclick', function(e) {
            if (self._state.draw.getFeature()) {
                self._state.draw.interaction.removeLastPoint();
                self._state.draw.interaction.removeLastPoint();
            }

            self._clickPixel(self._state.map.getEventPixel(e));
        });
    };

    _rightClickHandler = (e) => {
        let self = this;

        if (!self._state.draw.isEmpty()) {
            self._state.draw.interaction.removeLastPoint();
            return;
        }

        if (!self._state.draw.isEmpty()) {
            return;
        }

        self._clickPixel(self._state.map.getEventPixel(e));
    };

    _clickPixel = (pixel) => {
        let self = this;

        const feature = self._getFeatureAtPixel(pixel);

        if (!feature) return;

        self._args.events && self._args.events.clicked && self._args.events.clicked(feature);
    };

    _getFeatureAtPixel = (pixel) => {
        let self = this;

        let polygonFeature = null;

        self._state.map.forEachFeatureAtPixel(pixel, function(feature, layer) {
            if (feature.getGeometry().getType() === 'Polygon' && self._state.features.getArray().indexOf(feature) > -1) {
                polygonFeature = feature;
            }
        });

        return polygonFeature;
    };

    _removeStyleFromFeatures = (currentFeature) => {
        let self = this;

        self._state.sourceVector.getFeatures().forEach(function(feature) {
            if (currentFeature != undefined && feature.ol_uid !== currentFeature.ol_uid) {
                feature.setStyle(null);
            }
        });
    };

    _created = () => {
        let self = this;

        self._setColor(0, '#fa8174');
        self._setColor(1, '#fa8174');
    };

    getPolygons = () => {
        let self = this;

        return self._state.features.getArray();
    };

    deletePolygon = (polygon) => {
        let self = this;

        self._state.sourceVector.removeFeature(polygon);
        self._state.select.clear();
    };

    _init = () => {
        let self = this;

        self._createMap();
        self._created();
    };

    _init2 = () => {
        let self = this;

        self._state.vectors.push(self._createVector(0));
        self._state.vectors.push(self._createVector(1));
        self._state.imageLayer = self._createImageLayer();
        self._state.overlay    = self._createOverlay(document.getElementById('popup'));
        self._state.view       = self._createView();

        self._setColor(0, '#fa8174');
        self._setColor(1, '#fa8174');

        let source = self._state.vectors[1].getSource();

        self._state.map = new Map({
            //layers: [raster, vector],
            layers: 		[ self._state.imageLayer ].concat(self._state.vectors),
            overlays: 	    [ self._state.overlay ],
            controls: 		Control.defaults({
                zoom        : true,
                attribution : false,
                rotate      : false
            }),
            target          : self._args.target,
            view            : self._state.view
        });

        let fullscreen = new Control.FullScreen();
        self._state.map.addControl(fullscreen);

        var selected = null;
        var status = document.getElementsByClassName('header__logo');

        self._setDraw();

        var highlightStyle = new Style({
            fill: new Fill({
                color: 'rgba(255,255,255,0.7)'
            }),
            stroke: new Stroke({
                color: '#3399CC',
                width: 3
            })
        });

        self._state.map.on('pointermove', function(e) {
            if (selected !== null) {
                selected.setStyle(undefined);
                selected = null;
            }

            self._state.map.forEachFeatureAtPixel(e.pixel, function(f) {
                selected = f;
                f.setStyle(highlightStyle);
                return true;
            });

            if (selected) {
                status.innerHTML = '&nbsp;Hovering: ' + selected.get('name');
            } else {
                status.innerHTML = '&nbsp;';
            }
        });
    }
}

export default Polygon;